export const toggleBodyTagMovement = (toggle: boolean) => {
  const body = document.body;
  const className = 'fix'; // taken from layout.scss

  if (toggle) {
    body.classList.add(className);
  } else {
    body.classList.remove(className);
  }
};
